import { useState } from "react";
import { Col, Row } from "react-styled-flexboxgrid";
import { Color } from "../../theme/Color";
import Button from "../Button/Button";
import Input from "./Input";
import InputWrapper from "./InputWrapper";
import { HTTP_METHOD, fetchAPI } from "../../includes/fetch";

const ContactForm = () => {
  const [showThrobber, setShowThrobber] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const Submit = async (e) => {
    e.preventDefault();

    await fetchAPI("/api/contact", HTTP_METHOD.POST, {
      name: e.target.name.value,
      telephone: e.target.telephone.value,
      email: e.target.email.value,
      message: e.target.message.value,
    });

    setSubmitted(true);
  };

  if (submitted) {
    return <p>Thank you for your message we will get back to you shortly.</p>;
  }

  return (
    <form onSubmit={Submit}>
      <InputWrapper>
        <Col xs={12}>
          <label htmlFor="name">Name *</label>
        </Col>
        <Col xs={12}>
          <Row>
            <Input data-cy="register-name" name="name" required></Input>
          </Row>
        </Col>
      </InputWrapper>
      <InputWrapper>
        <Col xs={12}>
          <label htmlFor="name">Telephone</label>
        </Col>
        <Col xs={12}>
          <Row>
            <Input data-cy="contact-telephone" name="telephone"></Input>
          </Row>
        </Col>
      </InputWrapper>
      <InputWrapper>
        <Col xs={12}>
          <label htmlFor="name">Email</label>
        </Col>
        <Col xs={12}>
          <Row>
            <Input data-cy="contact-email" type="email" name="email"></Input>
          </Row>
        </Col>
      </InputWrapper>
      <InputWrapper>
        <Col xs={12}>
          <label htmlFor="message">Your Message *</label>
        </Col>
        <Col xs={12}>
          <Row>
            <textarea
              data-cy="contact-message"
              name="message"
              required
              style={{ border: `1px solid ${Color.Grey7}` }}
            ></textarea>
          </Row>
        </Col>
      </InputWrapper>
      <Row>
        <Button
          dataCy="submit"
          label={showThrobber ? "" : "Send Message"}
          showThrobber={showThrobber}
          onClick={() => setShowThrobber(true)}
        />
      </Row>
    </form>
  );
};
export default ContactForm;
